import { type Capture, type IdCallback } from '@canvas/input-types';
import { type CanvasHTMLElement } from '@canvas/input-types/base-event-types';

import { getInputTarget } from '../input-target/get-input-target';

/**
 * Adds event listeners and massages our event data, adding the resulting data to a stream.
 * Returns a cleanup function for removing event listeners.
 */
export const setupFocusEvents = (
  root: CanvasHTMLElement,
  id: IdCallback,
  onCapture: (capture: Capture) => void
): (() => void) => {
  const onFocused = (evt: FocusEvent) => {
    const target = getInputTarget(evt.target);
    onCapture({
      id: id(),
      type: 'focused',
      target,
      properties: {},
    });
  };

  const onBlurred = (evt: FocusEvent) => {
    const target = getInputTarget(evt.target);
    onCapture({
      id: id(),
      type: 'blurred',
      target,
      properties: {},
    });
  };

  root.addEventListener('focusin', onFocused);
  root.addEventListener('focusout', onBlurred);

  return () => {
    root.removeEventListener('focusin', onFocused);
    root.removeEventListener('focusout', onBlurred);
  };
};
